import client from './client';
import { Survey, PaginatedResponse } from '../types';

export const surveyApi = {
  list: (params?: { status?: string }) =>
    client.get<PaginatedResponse<Survey>>('/surveys', { params }),

  get: (id: string) => client.get<Survey>(`/surveys/${id}`),

  create: (data: Partial<Survey>) =>
    client.post<Survey>('/surveys', data),

  update: (id: string, data: Partial<Survey>) =>
    client.put<Survey>(`/surveys/${id}`, data),

  delete: (id: string) => client.delete(`/surveys/${id}`),

  send: (id: string) => client.post(`/surveys/${id}/send`),

  getPublic: (id: string) => client.get<Survey>(`/surveys/${id}/public`),

  respond: (id: string, data: { answers: { question_id: string; value: string | number }[]; department?: string }) =>
    client.post(`/surveys/${id}/respond`, data),

  results: (id: string) =>
    client.get<{
      response_count: number;
      response_rate: number;
      results: { question_id: string; question_text: string; type: string; summary: Record<string, number> }[];
      by_department: Record<string, Record<string, number>>;
    }>(`/surveys/${id}/results`),
};
